import { useFindServicesForReview } from "./useFindServicesForReview";

type NotificationState = {
  Calendar: boolean;
  Dashboard: boolean;
  MyHome: boolean;
};

export const useNavNotificationsState = () => {
  const { servicesForReview, servicesToRetryPayment } = useFindServicesForReview();
  const showNotifyCalendar =
    (servicesForReview && servicesForReview?.length > 0) ||
    (servicesToRetryPayment && servicesToRetryPayment?.length > 0);

  return {
    Calendar: showNotifyCalendar,
    Dashboard: false,
    MyHome: false,
  } as NotificationState;
};
